module.exports = __webpack_public_path__ + "static/img/index_01_03.8a0400b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_01_03.png
// module id = U3Xk
// module chunks = 1